import * as React from 'react';
import styles from './index.less';
import FIcons from '@/components/FIcons';

export interface FPodcastRssSubmitMethodPickerProps {
  className?: string;
  style?: React.CSSProperties;
  showLibrary?: boolean;
  showRss?: boolean;
  onSelectLibrary?(): void;
  onSelectRss?(): void;
  renderLibraryOption?(children: React.ReactNode): React.ReactNode;
}

function FPodcastRssSubmitMethodPicker({
  className = '',
  style,
  showLibrary = true,
  showRss = true,
  onSelectLibrary,
  onSelectRss,
  renderLibraryOption,
}: FPodcastRssSubmitMethodPickerProps) {
  const libraryCard = (
    <div
      className={styles.option}
      onClick={onSelectLibrary}
      role='button'
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          onSelectLibrary?.();
        }
      }}
    >
      <div className={styles.iconWrap}>
        <FIcons.FResourceFile style={{ fontSize: 64, color: '#222' }} />
      </div>
      <div className={styles.optionTitle}>从我的资源库中添加</div>
      <div className={styles.optionDesc}>
        直接从您在平台上传的文件中选择音轨，创建一个全新的播客节目。
      </div>
    </div>
  );

  const rssCard = (
    <div
      className={[styles.option, styles.optionRss].join(' ')}
      onClick={onSelectRss}
      role='button'
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          onSelectRss?.();
        }
      }}
    >
      <div className={styles.iconWrap}>
        <FIcons.FResourceFile style={{ fontSize: 64, color: '#222' }} />
      </div>
      <div className={styles.optionTitle}>通过 RSS 订阅地址创建</div>
      <div className={styles.optionDesc}>
        如果您在其他平台已有节目，只需提交 RSS 地址，我们将自动同步所有内容。
      </div>
    </div>
  );

  return (
    <div className={[styles.root, className].join(' ')} style={style}>
      <div className={styles.title}>单品添加方式</div>
      <div className={styles.options}>
        {showLibrary && (
          <div className={styles.optionCell}>
            {renderLibraryOption ? renderLibraryOption(libraryCard) : libraryCard}
          </div>
        )}
        {showRss && <div className={styles.optionCell}>{rssCard}</div>}
      </div>
    </div>
  );
}

export default FPodcastRssSubmitMethodPicker;
